import React from "react"

import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const"

export default function FieldStoryPoint_QuickFilterView(props: FieldQuickFilterViewProps) {

    const {value} = props

    let label   = 'Unknown'

    const classes = Classes("ui5-group-by-view", props.className)

    switch (value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All story points'
            return (
                <div className={classes}>
                    <div className="name">{label}</div>
                </div>
            )

        case null:
        case 'null':
            return (
                <div className={classes}>
                    <div className="name">Not set</div>
                </div>
            )

        default:
            const options = gd.company.settings.fields.storyPoints;

            let valueLabel = '';
            if (!_.isNil(value)) {
                const found = _.find(options, option=>option.value === value);
                valueLabel = found ? found.label : value;
            }

            const labelClasses = Classes("ui5-story-points s-24", {
                'not-set': _.isNil(value)
            })

            return (
                <div className={classes}>
                    {/*<div className="name">{label}</div>*/}
                    <div className={labelClasses}>{valueLabel}</div>
                </div>
            )
    }







}